import React, { useState } from 'react';

import firebase from 'firebase/compat/app';
import db from '../../firebase'

import SubHeading from '../SubHeading/SubHeading';
import './Newsletter.css';

const Newsletter = () => {
  const [input, setInput] = useState('');
  const [message, setMessage] = useState('');
  const inputHandler = (e) => {
    setInput(e.target.value);
  }
  const submitHandler = (e) => {
    e.preventDefault();
    if (input) {
      console.log(input);
      // add Firebase or Mailchimp
      db.collection('emails').add({
        email: input,
        time: firebase.firestore.FieldValue.serverTimestamp(),
      })
      setInput('');
      setMessage('Thank you for subscribing!');
      setTimeout(() => {
        setMessage('');
      }, 4000)
    }
  };
  return (
    <div className="app__newsletter">
      <div className="app__newsletter-heading">
        <SubHeading title="Newsletter" />
        <h1 className="headtext__cormorant">Subscribe To Our Newsletter</h1>
        <p className="p__opensans">And never miss latest Updates!</p>
      </div>
      <div className="app__newsletter-input flex__center">
        <form onSubmit={submitHandler}>
          <input type="email" onChange={inputHandler} value={input} className='app__newsletter-input_email' placeholder="Enter your email address" required pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$' />
          <button type="submit" className="custom__button">Subscribe</button>
        </form>
      </div>
      <div className='app__newsletter-success p__opensans'>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Newsletter;
